var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditFilled = function SvgEditFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.217 7.875 4.1-4.108 2.916 2.916-4.108 4.1a.829.829 0 0 1-.467.25l-1.833.367a.888.888 0 0 1-.208.025c-.275 0-.534-.108-.734-.308-.25-.25-.35-.6-.283-.942l.367-1.833a.83.83 0 0 1 .25-.467Zm8.541-4.192-1.441-1.441c-.409-.4-1.067-.4-1.475 0l-.642.641L17.117 5.8l.641-.642c.4-.408.4-1.066 0-1.475Zm-1.091 4.6a.63.63 0 0 0-.625.625v7.134H3.958V3.958h7.159a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625H3.75c-.575 0-1.042.467-1.042 1.042v12.5c0 .575.467 1.042 1.042 1.042h12.5c.575 0 1.042-.467 1.042-1.042V8.908a.63.63 0 0 0-.625-.625Z",
    fill: "current"
  })));
};
export default SvgEditFilled;